import { Component, AfterViewInit, Input } from '@angular/core';

import { TipoContato } from "../contato-tipos/shared/contato-tipo.model";
import { ContatoTipoApiService } from "../contato-tipos/shared/contato-tipo-api.service";
import { ContatoTipoService } from "../contato-tipos/shared/contato.service";

@Component({
    selector: 'app-contato-form',
    template: require('./contato-form.component.html'),
    styles: [require('./contato-form.component.css')]
})
export class ContatoFormComponent implements AfterViewInit {
    @Input() list: any[] = [];

    tiposList: TipoContato[] = [];
    isPhone: boolean[] = [];

    constructor(
        private _contatoTipoApiService: ContatoTipoApiService,
        private _contatoTipoService: ContatoTipoService
    ) {}

    ngAfterViewInit() {
        this.getTipos();
        if (!this.list.length) {
            this.newContato();
        }
    }

    clickAddNew() {
        this.newContato();
    }

    changeTipo(item: any, i: number) {
        this.setIsPhone(item.tipo.id, i)
    }

    clickRemove(index: number) {
        this.list.splice(index, 1);
    }

    private getTipos() {
        var onDone = (function(Response: any) {
            if (!Response.error) {
                this.tiposList = Response;
                this.setTiposContatos();
            }
        }.bind(this));

        this._contatoTipoApiService.onGetAll(onDone);
    }

    private newContato() {
        var object: any = {ativo: true, tipo: this.tiposList[0]};
        this.list.push(object);
        this.isPhone.push(true);
    }

    private setIsPhone(tipoId: number, index: number) {
        var tipo: boolean = false;
        tipo = this._contatoTipoService.getTipoTelefoneCelular(tipoId);
        if (tipo) {
            this.isPhone[index] = true;
        } else {
            this.isPhone[index] = false;
        }
    }

    private setTiposContatos() {
        var x: any, lenX: any, y: any, lenY: any;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
            if (!this.list[x].tipoContatoId) {
                this.list[x].tipoContatoId = this.tiposList[0].id;
            }

            for (y = 0, lenY = this.tiposList.length; y < lenY; y++) {
                if (this.list[x].tipoContatoId === this.tiposList[y].id) {
                    this.isPhone.push(true);
                    this.setIsPhone(this.list[x].tipoContatoId, x);
                    this.list[x].tipo = this.tiposList[y];
                    break;
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/contatos/contato-form/contato-form.component.ts
 **/